module.exports = __webpack_public_path__ + "img/john-alt.7fef353c.png";